import { MATERIAL_MANAGEMENT_FEATURE_FLAG } from 'core/service/feature-flag/feature-flag.constants';
import { useAuthContext } from 'core/auth/hooks/use-auth-context.hook';
import { useGetEnabledFeatureFlags } from 'core/contexts/feature-flags/hooks/use-get-enabled-feature-flags.hook';
import { appRoles } from 'core/constants/constants';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsSideBarSection } from '../components/side-menu-list';
import { settingsModulePaths } from 'core/routes/routes';

export const useSettingsSideBarAOMMenu = (): SettingsSideBarSection[] => {
    const { t } = useTranslation();
    const { userRole } = useAuthContext();
    const enabledFeatureFlags = useGetEnabledFeatureFlags();
    const isMaterialManagementEnabled = enabledFeatureFlags.includes(MATERIAL_MANAGEMENT_FEATURE_FLAG);
    const isPoccAdmin = userRole === appRoles.POCC_ADMIN;

    return [
        {
            title: t('settings.menu.general'),
            items: [
                {
                    title: t('settings.menu.general.automation-rules'),
                    url: settingsModulePaths.automationRules,
                },
                {
                    title: t('settings.menu.general.active-directory'),
                    url: settingsModulePaths.activeDirectoryList,
                },
                {
                    title: t('settings.menu.general.custom-fields'),
                    url: settingsModulePaths.customFields,
                },
                {
                    title: t('settings.menu.devicesManagement.deviceTypes'),
                    url: settingsModulePaths.deviceTypes,
                },
                ...(isPoccAdmin
                    ? [
                          {
                              title: t('settings.menu.general.user-location-assignment'),
                              url: settingsModulePaths.userLocationAssignment,
                          },
                      ]
                    : []),
            ],
        },
        ...(isPoccAdmin
            ? [
                  {
                      title: t('settings.menu.operatorManagement'),
                      items: [
                          {
                              title: t('settings.menu.operatorManagement.custom-notifications'),
                              url: settingsModulePaths.operatorCustomNotifications,
                          },
                      ],
                  },
              ]
            : []),
        {
            title: t('settings.menu.trainingManagement'),
            items: [
                {
                    title: t('settings.menu.trainingManagement.training-settings'),
                    url: settingsModulePaths.trainingSettings,
                },
                {
                    title: t('settings.menu.trainingManagement.lms-api-integration'),
                    url: settingsModulePaths.lmsIntegration,
                },
            ],
        },
        ...(isMaterialManagementEnabled
            ? [
                  {
                      title: t('settings.menu.material-management.title'),
                      items: [
                          {
                              title: t('settings.menu.material-management.material-definitions'),
                              url: settingsModulePaths.materialDefinitions,
                          },
                      ],
                  },
              ]
            : []),
    ];
};
